module.exports = __webpack_public_path__ + "img/square-2.1019d527.svg";